import {trackEvent} from '@jetbrains/teamcity-ui/statistics'

export const trackPageOpen = () => trackEvent({name: 'page.open', groupId: 'page.events.group'})
